import React from 'react';

export const LookerStudioIframe = ({ embeddedLookerUrl }: { embeddedLookerUrl: string }) => {
  if (!embeddedLookerUrl) {
    return null;
  }

  return (
    <iframe
      title="Looker Viewer"
      src={embeddedLookerUrl}
      width="100%"
      height="768"
      style={{ border: 0 }}
      allowFullScreen
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    />
  );
};
